import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi.js";
import PurchaseModel from "../model/PurchaseModel.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetPurchase
 * @method apiRedeemUse
 */
export default {
    /**
     * @param {String} token
     * @param {Object} listConfig PurchaseListConfigModel - /service/config/HistoryConfigModel.js
     * @param {Object} filterListConfig PurchaseFilterConfigModel - /service/config/HistoryConfigModel.js
     */
    apiGetPurchase: function(token, listConfig, filterListConfig) {
        var params = listConfig.getParams();
        if (filterListConfig) {
            var filter = filterListConfig.getParams();
            params = { ...params, ...filter };
        }

        const url = ConfigManager.getApiUrl() + "/redeem";
        return BzbsApi.connectBzbsGet(url, token, params).pipe(
            map(res => {
                var purchases = [];
                for (var item of res.data) {
                    var purchase = new PurchaseModel(item);
                    purchases.push(purchase);
                }
                return purchases;
            })
        );
    },

    /**
     * @param {String} token
     * @param {String} redeemKey
     */
    apiRedeemUse: function(token, redeemKey) {
        const url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}/use`;
        return BzbsApi.connectBzbsPost(url, token).pipe(
            map(res => {
                return res.data;
            })
        );
    },
    // apiRedeeCode: function (token, param) {
    //     let nextMonth = '';
    //     let nextYear = '';
    //     if (parseInt(param.month) < 12) {
    //         nextYear = param.year;
    //         nextMonth = parseInt(param.month) + 1;
    //     } else {
    //         nextYear = parseInt(param.year) + 1;
    //         nextMonth = '1'
    //     }
    //     let strMonth = '';
    //     if (nextMonth < 10) {
    //         strMonth = '0' + nextMonth.toString();
    //     } else {
    //         strMonth = nextMonth.toString();
    //     }
    //     let strYear = nextYear.toString();
    //     var strUrl =
    //         ConfigManager.getApiUrl() +
    // 		'/redeem' +
    //         '?byConfig=true' +
    //         '&config=purchase' +
    // 		'&top=25' +
    //         '&device_app_id=' +
    // 		ConfigManager.getAppId() +
    // 		'&startdate='+ param.year +'-'+ param.month + '-01T00:00:00'+
    //         '&enddate='+ strYear +'-'+ strMonth + '-01T00:00:00';
    //         // console.log("url", strUrl);
    // 	return BzbsApi.connectBzbsGet(strUrl, token, null);
    // },
    getPointLog: function(token, param) {
        var strUrl =
            ConfigManager.getApiUrl() +
            "/log/points?device_app_id=" +
            ConfigManager.getAppId() +
            "&type=earn" +
            "&top=25" +
            "&lastRowKey=" +
            param.nextpage +
            "&month=" +
            param.date;
        // '&month='+ param.year +'-'+ param.month + '-01T00:00:00';
        return BzbsApi.connectBzbsGet(strUrl, token, null);
    },
    GetBlob() {
        const url = `${ConfigManager.getBlobUrl()}/config/suntory/annoucement/config.json`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    // console.log(response);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
